<style>
     .attendeeMod .socialSec{
      list-style: none;
    }
    .attendeeMod  #sp-attendee .contact-info{
      width:100%;
    }
    .attendeeMod  .attendee-details-popup#sp-attendee .socialSec ul{
      margin:0;
    }
    .attendeeMod  .attendee-details-popup#sp-attendee .socialSec ul li{
      display:inline-block;
    }
    .attendeeMod  .attendee-details-popup#sp-attendee .socialSec ul li img{
          width: 30px !important;
          margin: 0 7px;
    }
    .attendeeMod  .attendee-details-popup#sp-attendee{
        height: auto;
        width: auto;
        max-width: none;
          max-height: none;
    }
     .attendeeMod .attendee-details-popup#sp-attendee ul li{
        justify-content: flex-start;
        padding-bottom:6px;
    }
    .attendeeMod  #sp-attendee .sponsors-box-hld{
      height:100%;
    }
     .attendeeMod .speaker-website a{
          color: #469ae9;
        margin-top:10px;
        display:block;
    }
     .attendeeMod .meeting-list.attendee-list .sponsors-box-hld h4.speaker-prof-info{
      font-size:18px;
      margin:0;
    }
     .attendeeMod .sponsors-box-hld .grey-bg-texthld p,
 .attendeeMod .meeting-list.attendee-list .sponsors-box-hld  .grey-bg-texthld h4{
      font-size: 16px;
    margin-bottom: 0;
    color: #737373;
    letter-spacing: 0.3px;
}

   .attendeeMod   .meeting-list.attendee-list .sponsors-box-hld.sponsors-box-hld.profile-holder{
      display:flex;
      flex-direction: row;
          align-items: center;
    }
   .attendeeMod   .top-img-box.porfile-img{
      width:140px;
    }
    .attendeeMod  .attendee-details-popup .sponsors-box-hld .grey-bg-texthld{
      text-align:left;
      margin-top:0;
    }
    .attendeeMod  .attendee-details-popup.meeting-list.attendee-list span.attendee-img-area{
      height: 110px;
      width: 110px;
      max-width: 110px;
      min-height: 110px;
      max-height: 110px;
      min-width: 110px;
      margin:0;
    }
   .attendeeMod .meeting-list.attendee-list .top-img-box {
      padding: 0 20px 0 0;
  }
   .attendeeMod .attendee-details-popup#sp-attendee .socialSec ul {
      text-align: left;
  }
    .attendeeMod .socialSec ul {
      display:flex;
    }
  .attendeeMod .socialSec ul li a{
        width: 40px;
    height: 40px;
    border: 1px solid #ddd;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right:10px;
  }
  .attendeeMod .socialSec ul li a svg {
    fill: #cc1022;
  }
  .attendeeMod .attendee-details-popup .sponsors-box-hld ul li span a {
      color: #242432;
      font-size: 16px;
  }
  .attendeeMod .attendee-details-popup .contact-info ul{
    margin-top: 10px !important;
    margin-bottom: 0;
  }
  .attendeeMod .right-speaker-text{
    display:flex;
        min-height: 330px;
  }
 .attendeeMod .right-speaker-text .right-side-attendee-des{
    align-self: center;
    color: #404040;
    letter-spacing: 0.5px;
    font-size: 15px;
  }
.porfile-right {
  width: calc(100% - 160px);
}


/* width */
.attendeeMod .right-speaker-text .right-side-attendee-des::-webkit-scrollbar {
  width: 10px;
}

/* Track */
.attendeeMod .right-speaker-text .right-side-attendee-des::-webkit-scrollbar-track {
  background: #f0f0f0;
}

/* Handle */
.attendeeMod .right-speaker-text .right-side-attendee-des::-webkit-scrollbar-thumb {
  background: #bfbfbf;
}

/* Handle on hover */
.attendeeMod .right-speaker-text .right-side-attendee-des::-webkit-scrollbar-thumb:hover {
  background: #bfbfbf;
}
</style>
<template>
  <!----speaker details popup start------>
  <div
    class="attendeeMod modal fade spe_detsila"
    id="attendee-details"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-body">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18.03"
              height="18.031"
              viewBox="0 0 18.03 18.031"
            >
              <path
                id="close.svg"
                fill="#242432"
                d="M1422.25,525.005l7.51,7.508a0.885,0.885,0,0,1,0,1.243,0.876,0.876,0,0,1-1.24,0l-7.51-7.508-7.51,7.508a0.876,0.876,0,0,1-1.24,0,0.867,0.867,0,0,1,0-1.243l7.51-7.508-7.51-7.507a0.878,0.878,0,0,1,1.24-1.243l7.51,7.508,7.51-7.508a0.874,0.874,0,0,1,1.24,0,0.885,0.885,0,0,1,0,1.243Z"
                transform="translate(-1412 -516)"
              />
            </svg>
          </button>
          <div class="attendee-details-popup meeting-list attendee-list speakers_details_modal"  id="sp-attendee">
            <div class="row align-items-center">
              <div class="col-md-6">
                <div class="sponsors-box-hld profile-holder">
                  <div class="top-img-box porfile-img mb-0">
                    <span class="attendee-img-area" v-if="ProfilePictureURL">
                      <img v-bind:src="ProfilePictureURL" />
                    </span>
                     <span class="attendee-img-area" v-if="!ProfilePictureURL && Initials">
                      <span v-html="Initials"></span>
                    </span>                      
                  </div>
                  <div class="porfile-right pl-md-3">
                    <div class="grey-bg-texthld">
                        <h3>{{Name}}</h3>
                        <h4>{{Designation}}</h4>
                        <p>{{Company}}</p>
                      </div>
                    <div class="contact-info">
                      <ul class="p-0"> 
                        <li v-if="Email">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12"> 
                            <path id="mail.svg" style="fill: #aeb2ba; fill-rule: evenodd;" d="M416.6,2318.01a1.617,1.617,0,0,0-1.144.43,1.424,1.424,0,0,0-.468,1.07v8.98a1.409,1.409,0,0,0,.468,1.07,1.583,1.583,0,0,0,1.144.44h12.788a1.579,1.579,0,0,0,1.143-.44,1.406,1.406,0,0,0,.469-1.07v-8.98a1.421,1.421,0,0,0-.469-1.07,1.613,1.613,0,0,0-1.143-.43H416.6Zm6.375,6.73-6.375-3.72v-1.51l6.375,3.76,6.413-3.76v1.51Z" transform="translate(-415 -2318)"/>
                          </svg>
                          <span class="pl-0">
                            <a v-bind:href="'mailto:' + Email">{{Email}}</a>
                          </span>
                        </li>                    
                        <li v-if="Phone">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                            <path style="fill: #aeb2ba; fill-rule: evenodd;" id="phone.svg" class="cls-1" d="M420.476,2351.26a0.916,0.916,0,0,0,.221-0.98,10.537,10.537,0,0,1-.531-3.36,0.911,0.911,0,0,0-.266-0.64,0.84,0.84,0,0,0-.664-0.29h-3.32a0.86,0.86,0,0,0-.642.29,0.875,0.875,0,0,0-.288.64,15.818,15.818,0,0,0,2.147,8.08,10.983,10.983,0,0,0,4.844,4.84,15.818,15.818,0,0,0,8.079,2.15,0.9,0.9,0,0,0,.642-0.29,0.875,0.875,0,0,0,.288-0.64v-3.32a0.876,0.876,0,0,0-.288-0.67,0.951,0.951,0,0,0-.642-0.26,10.684,10.684,0,0,1-3.364-.53,0.8,0.8,0,0,0-.974.22l-2.081,2.08a9.925,9.925,0,0,1-5.242-5.24Z" transform="translate(-415 -2346)"/>
                          </svg>
                          <span>
                            <a v-bind:href="'tel:' + Phone">{{Phone}}</a>
                          </span>
                        </li>
                        <li v-if="Website">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                            <path style="fill: #aeb2ba;  fill-rule: evenodd;" d="M1801,560.007a8.007,8.007,0,1,1,8.01-8.007A8.011,8.011,0,0,1,1801,560.007Zm-1.44-5.558a0.724,0.724,0,0,0-.26-0.753l-0.62-.5s-0.28-.4-0.47-0.753a7.982,7.982,0,0,0-.95-1.382,4.743,4.743,0,0,1-.31-2.449,1.7,1.7,0,0,0-.19-1.108,6.1,6.1,0,0,0,3.94,10.523,1.854,1.854,0,0,0,.08-0.749,10.236,10.236,0,0,1-1.16-1.57A4.877,4.877,0,0,1,1799.56,554.449Zm4.49-7.738-0.26.7a3.882,3.882,0,0,1,.66.691,1.352,1.352,0,0,1-.34,1.759c-0.79.454-2,.253-2.23,0.973s-0.13,1.175-1.29,1.036c0.55,0.481.76,0.691,0.76,0.691a1.29,1.29,0,0,1,1.09.063c0.4,0.322,1.17.783,1.45,1a1.952,1.952,0,0,0,.85.471,1.144,1.144,0,0,1,.88.534,1.375,1.375,0,0,0,.28.772A6.078,6.078,0,0,0,1804.05,546.711Z" transform="translate(-1793 -544)"/>
                          </svg>
                          <span>
                            <a v-bind:href="Website" target="_blank">{{Website}}</a>
                          </span>
                        </li>
                      </ul>
                      <div class="socialSec">
                            <ul>
                                <li v-if="Facebook">
                                  <a v-bind:href="Facebook"  target="_blank">
                                      <svg enable-background="new 0 0 512 512" height="20px" id="Layer_1" version="1.1" viewBox="0 0 512 512" width="20px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                        <g><path d="M191.844,511.5V288.375h-68.313V188h69.875v-83.063c0,0,3.188-104.625,92.813-105.438h99.75V98h-61.875   c0,0-26.125,0-26.125,29.438c0,29.375,0,62.313,0,62.313h89.5l-10.75,100.313h-77.188V511.5H191.844z"/></g>
                                    </svg>
                                  </a>
                                </li>
                                <li v-if="Twitter">
                                  <a v-bind:href="Twitter" target="_blank">
                                    <svg id="Layer_1" height="48px" width="30px" style="enable-background:new 0 0 512 512; margin-bottom: 6px;" version="1.1" viewBox="0 0 512 512" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                      <path class="st0" d="M196.9,462c120.3,0,186.1-99.7,186.1-186.1c0-2.8,0-5.6-0.2-8.5c12.8-9.3,23.8-20.7,32.6-33.9  c-11.9,5.3-24.6,8.8-37.6,10.3c13.7-8.2,23.9-21,28.8-36.2c-12.8,7.6-26.9,13-41.5,15.9c-24.8-26.3-66.2-27.6-92.5-2.8  c-17,16-24.2,39.8-18.9,62.5c-52.6-2.6-101.6-27.5-134.8-68.3c-17.4,29.9-8.5,68.1,20.2,87.3c-10.4-0.3-20.6-3.1-29.7-8.2  c0,0.3,0,0.5,0,0.8c0,31.1,22,57.9,52.5,64.1c-9.6,2.6-19.7,3-29.5,1.1c8.6,26.6,33.1,44.9,61.1,45.4  c-23.2,18.2-51.8,28.1-81.2,28.1c-5.2,0-10.4-0.3-15.6-0.9C126.5,451.8,161.3,462,196.9,462" id="XMLID_22_"/>
                                    </svg>
                                  </a>
                                </li>
                                <li v-if="LinkedIn">
                                  <a v-bind:href="LinkedIn" target="_blank">
                                    <svg baseProfile="tiny" height="26px" id="Layer_1" version="1.2" viewBox="0 0 24 24" width="32px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                      <g>
                                      <path d="M8,19H5V9h3V19z M19,19h-3v-5.342c0-1.392-0.496-2.085-1.479-2.085c-0.779,0-1.273,0.388-1.521,1.165C13,14,13,19,13,19h-3   c0,0,0.04-9,0-10h2.368l0.183,2h0.062c0.615-1,1.598-1.678,2.946-1.678c1.025,0,1.854,0.285,2.487,1.001   C18.683,11.04,19,12.002,19,13.353V19z"/></g><g><ellipse cx="6.5" cy="6.5" rx="1.55" ry="1.5"/></g>
                                    </svg>
                                  </a>
                                </li>
                                <!-- <li>
                                  <a v-bind:href="GooglePlus"><img style="width:45px" src="data:image/svg+xml;base64,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"></a>
                                </li> -->
                            </ul>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6 right-speaker-text">
                <div class="right-side-attendee-des pt-1" style="overflow-y: auto;max-height: 400px;">
                  <p v-html="Profile"></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!----speaker details popup end------>
</template>

<script>
import db from "../components/firebaseInit";
//import { stream } from "xlsx/types";
let vm;
export default {
  data() {
    return {
      SpeakerId: "" //,
      //Profile: ""
    };
  },
  methods: {
    displayProfile: function() {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      db.collection(obj.eventcollectionname)
        .doc("SpeakerList")
        .collection("Speakers")
        .doc(vm.SpeakerId)
        .get()
        .then(function(doc) {
          debugger;
          if (doc.exists) {
            vm.Profile =
              doc.data().Profile == undefined ? "" : doc.data().Profile;
          }
        })
        .catch(function(error) {
          console.error("Error creating Exhibitor: ", error);
        });
    }
  },
  computed: {
    //sPprofile: async function() {
    //  var obj = JSON.parse(window.localStorage.getItem("my-app"));
    //  return await db
    //    .collection(obj.eventcollectionname)
    //    .doc("SpeakerList")
    //    .collection("Speakers")
    //    .doc(vm.SpeakerId)
    //    .get()
    //    .then(function(doc) {
    //      debugger;
    //      if (doc.exists) {
    //        //vm.Profile =
    //        //  doc.data().Profile == undefined ? "" : doc.data().Profile;
    //        return doc.data().Profile;
    //      }
    //    })
    //    .catch(function(error) {
    //      console.error("Error creating Exhibitor: ", error);
    //    });
    //}
  },
  mounted() {
    vm = this;
    vm.SpeakerId = vm.$vnode.key;
    //vm.displayProfile();
  },
  props: {
    AttendeeId: String,
    Name: String,
    Company: String,
    Designation: String,
    Email: String,
    Phone: String,
    Profile: String,
    ProfilePictureURL: String,
    Facebook: String,
    Twitter: String,
    LinkedIn: String,
    GooglePlus: String,
    Website: String,
    Initials: String
  }
};
</script>